(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
    typeof define === 'function' && define.amd ? define(['exports'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.Tracking = {}));
})(this, (function (exports) { 'use strict';

    // Name of the accessor for the dataLayer on the `window` object
    const DATALAYER = 'dataLayer';
    /**
     * Client for implementing GTM based tracking
     */
    class TrackingClient {
        constructor() {
            const w = window;
            w[DATALAYER] = w[DATALAYER] || [];
            this._dataLayer = w[DATALAYER];
        }
        /**
         * Add a GTM container to the DOM
         * @param id
         * @returns
         */
        async addGTMContainer(id) {
            return new Promise((resolve, reject) => {
                // Load Google Tag Manager js
                const d = document;
                const s = 'script';
                this.push({
                    'gtm.start': new Date().getTime(),
                    event: 'gtm.js',
                });
                const f = d.getElementsByTagName(s)[0];
                const j = d.createElement(s);
                const dl = '';
                j.async = true;
                j.src = `https://www.googletagmanager.com/gtm.js?id=${id}${dl}`;
                f.parentNode.insertBefore(j, f);
                // Insert Google Tag Manager IFrame
                const noscript = document.createElement('noscript');
                const iframe = document.createElement('iframe');
                // Resolve promise on load
                iframe.onload = () => resolve();
                iframe.onerror = () => reject();
                iframe.src = `https://www.googletagmanager.com/ns.html?id=${id}`;
                iframe.height = '0';
                iframe.width = '0';
                // @ts-ignore
                iframe.style = 'display:none;visibility:hidden';
                noscript.appendChild(iframe);
                const { body } = document;
                body.insertBefore(noscript, body.firstChild);
            });
        }
        /**
         * Push events to the dataLayer
         * @param event
         */
        push(event) {
            // Run async, as GTM/Analytics CAN take a while and block for MINUTES!
            // Depending on the amount of data pushed and the triggers executing for the tags!!!
            setTimeout(() => {
                if (Array.isArray(event)) {
                    this._dataLayer.push(...event);
                }
                else {
                    this._dataLayer.push(event);
                }
            }, 0);
        }
    }

    /**
     * The GTM compatibility class, these functions create events
     * with the same sructure and data as the old shop
     */
    class GTMEvent {
        static contentView(path, extra) {
            return {
                ...extra,
                event: 'content-view',
                'content-name': path,
            };
        }
        static interaction(path, action, name, event) {
            const data = {
                event: 'interaction',
                'content-name': path,
                action,
                category: 'OrderProcess',
                label: name,
            };
            if (event) {
                let price = 0;
                for (const item of event.items) {
                    price += item.pricing.total_price;
                }
                data.value = (price / 100).toFixed(2);
            }
            return data;
        }
        /**
         * Triggered when an event is selected
         */
        static impression(shop, items) {
            return {
                event: 'impression',
                ecommerce: {
                    impressions: items.map((item) => ({
                        ...item,
                        pricing: undefined,
                        price: (item.pricing.total_price / 100).toFixed(2),
                        list: shop.name,
                    })),
                },
            };
        }
        /**
         * Triggered for every route change, containing the
         * current and the previous route
         */
        static history(to, from) {
            return {
                event: 'gtm.historyChange',
                'gtm.newUrl': to,
                'gtm.oldUrl': from,
            };
        }
        /**
         * Triggered for cart add and remove events on tickets
         */
        static cartEvent(action, scope, event) {
            let price = 0;
            for (const item of event.items) {
                price += item.pricing.total_price;
            }
            return {
                event: action === 'add' ? 'addToCart' : 'removeFromCart',
                ecommerce: {
                    [action]: {
                        [scope]: [{
                                id: event.guid,
                                name: event.name,
                                price: (price / 100).toFixed(2),
                                quantity: event.items.length,
                            }],
                    },
                },
            };
        }
        /**
         * Triggered when the booker information becomes visible
         */
        static details(shop, items) {
            return {
                event: 'detail',
                ecommerce: {
                    detail: {
                        actionField: {
                            list: shop.name,
                            action: 'detail',
                        },
                        products: items.map((item) => ({
                            ...item,
                            pricing: undefined,
                            price: (item.pricing.total_price / 100).toFixed(2),
                            quantity: 1,
                            list: shop.name,
                        })),
                    },
                },
            };
        }
        /**
         * Triggered when the booker information becomes visible and again
         * when the payment method overview becomes visible
         */
        static checkout(shop, items, step) {
            return {
                event: 'checkout',
                ecommerce: {
                    checkout: {
                        actionField: {
                            step,
                            list: shop.name,
                            action: 'checkout',
                        },
                        products: items.map((item) => ({
                            ...item,
                            pricing: undefined,
                            price: (item.pricing.total_price / 100).toFixed(2),
                            quantity: 1,
                            list: shop.name,
                        })),
                    },
                },
            };
        }
    }

    exports.GTMEvent = GTMEvent;
    exports["default"] = TrackingClient;

    Object.defineProperty(exports, '__esModule', { value: true });

}));
//# sourceMappingURL=tracking.js.map
